/**
 * Algolia Insights (events) for venues and courts.
 * All events are sent via Cloud Functions (backend calls Algolia). No Algolia key on frontend.
 * - Click: when user selects a venue from search (queryID from algoliaSearchVenues).
 * - Conversion: when a court is booked.
 * - View: when user views a venue that has events or past bookings.
 */

import * as algoliaApi from '../api/algoliaApi';
import { ALGOLIA_VENUE_INDEX } from '../config/algolia';

/**
 * Send click event: user clicked a venue from search results.
 * Call after user selects a venue from VenueSearch (with queryID from that search).
 */
export function sendVenueClickedAfterSearch({ queryID, objectID, position }) {
  if (!queryID || !objectID) return;
  algoliaApi.insightClick({
    indexName: ALGOLIA_VENUE_INDEX,
    eventName: 'Venue Clicked',
    queryID,
    objectIDs: [objectID],
    positions: [position != null ? position : 1],
  }).catch((e) => console.warn('Algolia Insights click failed:', e?.message));
}

/**
 * Send conversion: court/venue booked by a GradedPlay user.
 * Call after creating a venue booking.
 */
export function sendVenueBookedConversion({ objectID, queryID }) {
  if (!objectID) return;
  algoliaApi.insightConversion({
    indexName: ALGOLIA_VENUE_INDEX,
    eventName: 'Court Booked',
    objectIDs: [objectID],
    queryID: queryID || undefined,
  }).catch((e) => console.warn('Algolia Insights conversion failed:', e?.message));
}

/**
 * Send view event: user viewed a venue that has events or past bookings (GradedPlay).
 * Call when displaying a venue that has venue bookings or tournament matches.
 */
export function sendVenueViewed({ objectID }) {
  if (!objectID) return;
  algoliaApi.insightView({
    indexName: ALGOLIA_VENUE_INDEX,
    eventName: 'Venue Viewed (has events)',
    objectIDs: [objectID],
  }).catch((e) => console.warn('Algolia Insights view failed:', e?.message));
}

/**
 * Set authenticated user token for Personalization. No-op when using backend proxy;
 * backend uses request.auth.uid as userToken for each event.
 */
export function setAlgoliaUserToken(/* userId */) {
  // Backend uses Firebase Auth uid per request; no client-side token needed.
}
